module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/high-capacity-transport-toolbar-50.2d7e98e7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/high-capacity-transport-toolbar-50.png
// module id = 3716
// module chunks = 11